import React from 'react'
import { subscribe } from 'react-contextual'
import { useSelector } from 'react-redux'
import { Modal, Button } from 'components'
import PortfoliosProvider from '../../PortfoliosProvider'
import { chatbotSelectors } from '../../../ui/ChatBot'
import styles from './ConfirmPortfolioActivation.module.scss'

const ConfirmPortfolioActivation = ({ activateCurrentPortfolio, declineActivationConfirmation }: any) => {
  const isActivationConfirmationOpen = useSelector(chatbotSelectors.isActivationConfirmationOpen)
  return (
    <Modal isOpen={isActivationConfirmationOpen} onClose={declineActivationConfirmation} className={styles.root}>
      <h3 className="Modal_Title">Activate lease?</h3>
      <div className="Modal_Content">
        <p>
          This will immediately send lease activation emails and generate all draft invoices. Any invoice templates
          added or updated after activation will only take effect from the next generation date (the 10th).
        </p>
        <div className="Modal_Actions">
          <Button link onClick={activateCurrentPortfolio}>
            Activate
          </Button>
          <Button link onClick={declineActivationConfirmation}>
            Go back
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default subscribe([PortfoliosProvider], ({ activateCurrentPortfolio, declineActivationConfirmation }: any) => ({
  activateCurrentPortfolio,
  declineActivationConfirmation,
}))(ConfirmPortfolioActivation)
